import React from 'react';
import {defaultPageConfig, Page} from "/src/domain/shared/Page";

import '../../i18n';

import {User, UserRole} from "/src/domain/shared/User";

import {mountComponentToContainer} from "/src/domain/shared/mountUtils";

import {ChallengeClubRatingData} from "/src/domain/challenges/ChallengeClubRatingData";
import {Movement} from "/src/domain/challenges/ChallengeRatingData";
import ChallengeClubRatingApp from "/src/ui/challengeClubRating/ChallengeClubRatingApp";

window.mountPage = mountPage;

function mountPage(page: Page, pageData: ChallengeClubRatingData, currentUser?: User) {
    if (page !== Page.CHALLENGE_CLUB_RATING) {
        console.error('Unknown page type');
        return;
    }

    mountComponentToContainer(page, pageData, currentUser, defaultPageConfig, ChallengeClubRatingApp)
}

// mountPage(Page.CHALLENGE_CLUB_RATING,
//     {
//         "ratingClub": [
//             {
//                 "id": "95592130",
//                 "firstName": "",
//                 "lastName": "viktor braun",
//                 "place": 1,
//                 "rating": 1245,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.UP
//             },
//             {
//                 "id": "91483378",
//                 "firstName": "",
//                 "lastName": "\u041b\u044e\u0434\u043c\u0438\u043b\u0430 \u0428\u0435\u0432\u0446\u043e\u0432\u0430",
//                 "place": 2,
//                 "rating": 1135,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.UP
//             },
//             {
//                 "id": "52600043",
//                 "firstName": "",
//                 "lastName": "\u0410\u043b\u0435\u043a\u0441\u0435\u0439 \u041b\u0435\u0431\u0435\u0434\u0435\u0432",
//                 "place": 3,
//                 "rating": 1108,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.UP
//             },
//             {
//                 "id": "26198549",
//                 "firstName": "",
//                 "lastName": "Dmitrij Zmeev",
//                 "place": 4,
//                 "rating": 1098,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "20166982",
//                 "firstName": "",
//                 "lastName": "Alexander Burdyga",
//                 "place": 5,
//                 "rating": 1095,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.UP
//             },
//             {
//                 "id": "57995230",
//                 "firstName": "",
//                 "lastName": "Fedor Ovchinnikov",
//                 "place": 6,
//                 "rating": 1066,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "1000002037",
//                 "firstName": "",
//                 "lastName": "\u041d\u0438\u043a\u043e\u043b\u0430\u0439",
//                 "place": 7,
//                 "rating": 1063,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "85039819",
//                 "firstName": "",
//                 "lastName": "Sergey Sapiyev",
//                 "place": 8,
//                 "rating": 1061,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "1000001648",
//                 "firstName": "",
//                 "lastName": "\u0415\u043b\u0435\u043d\u0430",
//                 "place": 9,
//                 "rating": 1061,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "18486907",
//                 "firstName": "",
//                 "lastName": "\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440 \u0422\u0430\u0440\u0430\u043d\u0447\u0435\u043d\u043a\u043e",
//                 "place": 10,
//                 "rating": 1059,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "1000000825",
//                 "firstName": "",
//                 "lastName": "\u041e\u043b\u044c\u0433\u0430 \u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u0430",
//                 "place": 11,
//                 "rating": 1059,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "7439904",
//                 "firstName": "",
//                 "lastName": "Yuri Strofilov #S10.run",
//                 "place": 12,
//                 "rating": 1057,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "1000001935",
//                 "firstName": "",
//                 "lastName": "\u042e\u043b\u0438\u044f \u041e\u0432\u0441\u044f\u043d\u043d\u0438\u043a\u043e\u0432\u0430",
//                 "place": 13,
//                 "rating": 1053,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "20230457",
//                 "firstName": "",
//                 "lastName": "Alexeeff Vladimir",
//                 "place": 14,
//                 "rating": 1052,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "1000001027",
//                 "firstName": "",
//                 "lastName": "\u0412\u0430\u043b\u0435\u043d\u0442\u0438\u043d\u0430 \u041f\u043e\u0442\u0435\u043c\u043a\u0438\u043d\u0430",
//                 "place": 15,
//                 "rating": 1052,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "23060357",
//                 "firstName": "",
//                 "lastName": "Anton Kulichenko",
//                 "place": 16,
//                 "rating": 1046,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "23012458",
//                 "firstName": "",
//                 "lastName": "Mikhail Popov",
//                 "place": 17,
//                 "rating": 1037,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "65495427",
//                 "firstName": "",
//                 "lastName": "Irina Klimova",
//                 "place": 18,
//                 "rating": 1024,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "95105476",
//                 "firstName": "",
//                 "lastName": "Petr Kazantsev",
//                 "place": 19,
//                 "rating": 1024,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.UP
//             },
//             {
//                 "id": "43627805",
//                 "firstName": "",
//                 "lastName": "\u041f\u0430\u0432\u0435\u043b \u0421\u0442\u0435\u0440\u0445\u043e\u0432",
//                 "place": 20,
//                 "rating": 990,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "28796495",
//                 "firstName": "",
//                 "lastName": "\u0415\u0433\u043e\u0440 \u0411\u043b\u0430\u0436\u0435\u0435\u0432",
//                 "place": 21,
//                 "rating": 989,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             },
//             {
//                 "id": "10937165",
//                 "firstName": "",
//                 "lastName": "Andrey Lvov",
//                 "place": 22,
//                 "rating": 964,
//                 "clubLogoUrl": "https:\/\/s10.run\/i\/team\/2.png",
//                 "movement": Movement.DOWN
//             }
//         ], "club": {"id": 2, "name": "S10 Team", "logoUrl": "https:\/\/s10.run\/i\/team\/2.png"}
//     }
//     ,
//     {
//         id: '50698840',
//         role: UserRole.STUDENT,
//         isPremium: false,
//         trainingsRequests: []
//     }
// )
